module.exports = __webpack_public_path__ + "img/ry_12.d85e6fc0.png";